import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import ResourceInfoPopover from '../../common/ResourceInfoPopover';
import { RESOURCE_LABEL } from '../../common/constants';
import UnsavedChangesWarning from '../../common/UnsavedChangesWarning';
import MssDelete from '../../common/MssDelete';
import Loader from '../../common/Loader';
import useDeleteSummary from './useDeleteSummary';

function EditSummaryHeader({
  summary,
  isLoading,
  isDirty,
  isSaveDisabled,
  onSave,
  onDeleted,
  savedAt,
}) {
  const courseId = useSelector((state) => state.course.courseId);

  const { summaryToDelete, isDeleting, promptDelete, cancelDelete, deleteSummary } =
    useDeleteSummary({
      courseId,
      onDeleted,
    });

  return (
    <>
      <Box className="resourceHeader" id="editSummary__box_header">
        <Box className="resourceTitleGroup">
          <Box className="resourceTitle">
            <Typography variant="h2" component="h1">
              Edit Summary Notes
            </Typography>
            <ResourceInfoPopover
              id="editSummary__button_info"
              name={summary.title}
              nameLabel={RESOURCE_LABEL.SUMMARY_NOTES}
              resources={summary.resources}
              lastEditedBy={summary.lastEditedBy}
              instructions='Click text to edit. Changes will not be saved until "Save" button is clicked.'
            />
          </Box>
        </Box>

        <Box className="resourceActions resourceActions--stack">
          <UnsavedChangesWarning isDirty={isDirty} savedAt={savedAt} />
          <Button
            variant="contained"
            className="mss__button"
            id="editSummary__button_delete"
            disabled={isLoading}
            onClick={() => promptDelete(summary)}
          >
            Delete Summary Note
          </Button>
          <Button
            variant="contained"
            className="mss__button primary"
            id="editSummary__button_save"
            disabled={isSaveDisabled}
            onClick={onSave}
          >
            Save
          </Button>
        </Box>
      </Box>

      <Loader id="editSummary__loader_deleting" isOpen={isDeleting} />
      {summaryToDelete && (
        <MssDelete
          id="editSummary__modal_confirmDelete"
          onToggle={cancelDelete}
          onDelete={deleteSummary}
          title="Delete Summary Note"
          resourceName={summaryToDelete.title}
          isLoading={isDeleting}
          maxWidth="sm"
        />
      )}
    </>
  );
}

export default EditSummaryHeader;
